import { Box, Typography } from '@mui/material'

interface PopularAirlinesProps {
    title: string
    summary: string
}

const PopularAirlines: React.FC<PopularAirlinesProps> = ({ title, summary }) => {
    return (
        <Box sx={{ mb: 3 }}>
            <Typography
                component="h2"
                variant="h6"
                sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.25rem' }, mb: 1.5 }}
            >
                {title}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                {summary}
            </Typography>
        </Box>
    )
}

export default PopularAirlines
export type { PopularAirlinesProps }
